/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DetailOilStoreTypeEntity } from '../models/DetailOilStoreTypeEntity';
import type { GetAllOilStoreTypesEntity } from '../models/GetAllOilStoreTypesEntity';
import type { UpdateOilStoreTypeEntity } from '../models/UpdateOilStoreTypeEntity';
import type { UpdateStoreTypeDto } from '../models/UpdateStoreTypeDto';
import type { UploadOilStoreTypeLogoDto } from '../models/UploadOilStoreTypeLogoDto';
import type { UploadOilStoreTypeLogoEntity } from '../models/UploadOilStoreTypeLogoEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OilStoreTypeService {

    /**
     * @returns GetAllOilStoreTypesEntity
     * @throws ApiError
     */
    public static oilStoreTypeControllerGetAll(): CancelablePromise<GetAllOilStoreTypesEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/oil-store-types',
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns UpdateOilStoreTypeEntity
     * @throws ApiError
     */
    public static oilStoreTypeControllerUpdate(
        id: string,
        requestBody: UpdateStoreTypeDto,
    ): CancelablePromise<UpdateOilStoreTypeEntity> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/oil-store-types/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns DetailOilStoreTypeEntity
     * @throws ApiError
     */
    public static oilStoreTypeControllerGetDetail(
        id: string,
    ): CancelablePromise<DetailOilStoreTypeEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/oil-store-types/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Upload logo cho loại cửa hàng xăng dầu
     * @param requestBody
     * @returns UploadOilStoreTypeLogoEntity
     * @throws ApiError
     */
    public static oilStoreTypeControllerUploadLogo(
        requestBody: UploadOilStoreTypeLogoDto,
    ): CancelablePromise<UploadOilStoreTypeLogoEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/oil-store-types/upload-logo',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
